
import meta_US from './../config/meta_US.json'

const RbMeta = function(){

	//Setting defaultLocale to en_US
	var defaultLocale = "meta_US";

	//Setting userLocale to en_US unless otherwise changed by the user
	var userLocale = "meta_US";

	var getBundle = function(locale){
		switch(locale){
			case "meta_US" : return meta_US;
			default: return meta_US;
		}
    }
    
	var replaceDynamicText = function(originalString,replaceStringArray)
	{
		for(var i=0;i<replaceStringArray.length;i++)
		{
		   var val = "{"+i+"}";
		   originalString = originalString.split(val).join(replaceStringArray[i]);
		}
		return originalString;
	}
	return {
		getText:function(rawTxt,replaceStringArray=[]){
			try{
				var rb = getBundle(userLocale);
				if(rb[rawTxt]){
					return (replaceStringArray.length>0) ? replaceDynamicText(rb[rawTxt],replaceStringArray) : rb[rawTxt];
				}
				else if(getBundle(defaultLocale)[rawTxt]){
					return (replaceStringArray.length>0) ? replaceDynamicText(getBundle(defaultLocale)[rawTxt],replaceStringArray) : getBundle(defaultLocale)[rawTxt];
				}
			}catch(e){
				console.error(e);
			}

			return (replaceStringArray.length>0) ? replaceDynamicText(rawTxt,replaceStringArray) : rawTxt;
		},
		setLocale:function(locale){
			userLocale = locale;
		},
		getLocale:function(){
			return userLocale;
		}
	}
}();

export default RbMeta;


// WEBPACK FOOTER //
// ./src/util/RbMeta.js